import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './store/authStore';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Warehouses from './pages/Warehouses';
import RawMaterials from './pages/RawMaterials';
import FinishedGoods from './pages/FinishedGoods';
import Production from './pages/Production';
import Sales from './pages/Sales';
import LadingBills from './pages/LadingBills';
import Transfers from './pages/Transfers';
import Reports from './pages/Reports';
import Users from './pages/Users';
import AuditLog from './pages/AuditLog';
import Inventory from './pages/Inventory';
import Purchases from './pages/Purchases';
import Accounting from './pages/Accounting';
import Chat from './pages/Chat';
import Shipments from './pages/Shipments';
import MiscGoods from './pages/MiscGoods';
import Costing from './pages/Costing';
import Expenses from './pages/Expenses';
import ReportBuilder from './pages/ReportBuilder';
import Prepayments from './pages/Prepayments';
import Payroll from './pages/Payroll';
import ImportData from './pages/ImportData';

function PrivateRoute({ children }) {
  const { token } = useAuthStore();
  return token ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }) {
  const { can } = useAuthStore();
  useAuthStore(s => s.user);
  return can('users.manage') ? children : <Navigate to="/" replace />;
}

/** v3.9: a page the user has no permission for sends them to the dashboard */
function Guard({ path, children }) {
  const canRoute = useAuthStore(s => s.canRoute);
  useAuthStore(s => s.user);
  return canRoute(path) ? children : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { background: '#0c1020', color: '#f1f3ff', border: '1px solid rgba(255,255,255,0.1)', fontSize: '13px', fontFamily: 'Vazirmatn Variable, Inter Variable, sans-serif' } }} />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="warehouses" element={<Guard path="/warehouses"><Warehouses /></Guard>} />
          <Route path="raw-materials" element={<Guard path="/raw-materials"><RawMaterials /></Guard>} />
          <Route path="finished-goods" element={<Guard path="/finished-goods"><FinishedGoods /></Guard>} />
          <Route path="production" element={<Guard path="/production"><Production /></Guard>} />
          <Route path="sales" element={<Guard path="/sales"><Sales /></Guard>} />
          <Route path="lading-bills" element={<Guard path="/lading-bills"><LadingBills /></Guard>} />
          <Route path="transfers" element={<Guard path="/transfers"><Transfers /></Guard>} />
          <Route path="inventory" element={<Guard path="/inventory"><Inventory /></Guard>} />
          <Route path="purchases" element={<Guard path="/purchases"><Purchases /></Guard>} />
          <Route path="accounting" element={<Guard path="/accounting"><Accounting /></Guard>} />
          <Route path="chat" element={<Chat />} />
          <Route path="shipments" element={<Guard path="/shipments"><Shipments /></Guard>} />
          <Route path="misc-goods" element={<Guard path="/misc-goods"><MiscGoods /></Guard>} />
          <Route path="costing" element={<Guard path="/costing"><Costing /></Guard>} />
          <Route path="expenses" element={<Guard path="/expenses"><Expenses /></Guard>} />
          <Route path="prepayments" element={<Guard path="/prepayments"><Prepayments /></Guard>} />
          <Route path="payroll" element={<Guard path="/payroll"><Payroll /></Guard>} />
          <Route path="import" element={<Guard path="/import"><ImportData /></Guard>} />
          <Route path="report-builder" element={<Guard path="/report-builder"><ReportBuilder /></Guard>} />
          <Route path="reports" element={<Guard path="/reports"><Reports /></Guard>} />
          <Route path="users" element={<AdminRoute><Users /></AdminRoute>} />
          <Route path="audit-log" element={<AdminRoute><AuditLog /></AdminRoute>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
